import { CAST_AI } from '@cast/constants';
import { Button, Icons, SxProps } from '@cast/design-system';

import {
  useIsClusterDemoMode,
  useIsOpDemoMode,
} from '@cast/infrastructure-demo';
import { DemoClusterHeader } from 'components/sticky-headers';
import { globalTourSteps } from 'constants/tour';
import { useAbility } from '@cast/shared-ability-data-access';
import { GlobalTourStep } from 'core/tour';
import { useEnableCastFeaturesDialog } from 'hooks/dialogs/cluster/useEnableCastFeaturesDialog';

import { useSecurityDemoVideoDialog } from '../_hooks/useSecurityDemoVideoDialog';

type Props = {
  sx?: SxProps;
};

export const SecurityDemoHeader = ({ sx }: Props) => {
  const canEdit = useAbility().can('update', 'Clusters');
  const { openSecurityDemoVideoDialog } = useSecurityDemoVideoDialog();
  const { openEnableCastFeaturesDialog } = useEnableCastFeaturesDialog();
  const isClusterDemoMode = useIsClusterDemoMode();
  const isOpDemoMode = useIsOpDemoMode();

  if (isClusterDemoMode || isOpDemoMode) {
    return (
      <DemoClusterHeader
        title={`Connect your cluster to be one step closer to using ${CAST_AI}`}
        actions={
          <Button
            testId="watch-security-video-button"
            variant="ghost"
            size="sm"
            endIcon={<Icons.Play />}
            onClick={() => openSecurityDemoVideoDialog()}
          >
            Watch security demo
          </Button>
        }
        sx={sx}
      />
    );
  }

  return (
    <DemoClusterHeader
      title={`Enable ${CAST_AI} Security to protect your infrastructure`}
      labelText="Security demo"
      actions={
        <>
          <Button
            testId="watch-video-button"
            variant="ghost"
            size="sm"
            endIcon={<Icons.Play />}
            onClick={() => openSecurityDemoVideoDialog()}
          >
            Watch video
          </Button>
          <GlobalTourStep
            step={globalTourSteps.enableSecurity}
            highlight="bubble"
            placement="top-end"
            beaconPosition={{ right: -8, top: 6 }}
          >
            <Button
              testId="enable-security-button"
              disabled={!canEdit}
              size="sm"
              onClick={() => openEnableCastFeaturesDialog()}
            >
              Enable security
            </Button>
          </GlobalTourStep>
        </>
      }
      showMainAction={false}
      sx={sx}
    />
  );
};
